const styles = (theme) => ({
  badge: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.green,
  },
  label: {
    fontWeight: 300,
    fontSize: '12px',
  },
  icon: {
    height: '25px',
    width: '25px',
    marginBottom: '5px',
  },
  navItem: {
    minWidth: '0',
    display: 'flex',
    justifyContent: 'end',
    flexDirection: 'column',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fill: theme.palette.text.primary,
    color: theme.palette.text.primary,
  },
  navItemActive: {
    fill: theme.palette.primary.red,
    color: theme.palette.primary.red,
  },
  notificationNumber: {
    position: 'absolute',
    width: '14px',
    height: '14px',
    borderRadius: '50%',
    padding: 0,
    justifyContent: 'center',
    right: '-10px',
    top: '-5px',
    fontSize: '10px',
  },
});

export default styles;
